import React from 'react';

import { OverhangSettings as OverhangSettingsData } from '@paragon/contract-library';

import { updateInsertingProfileTrussSettings } from '../../../../store/actions/profileActions';
import { getInsertingProfileTrussSettings } from '../../../../store/selectors/profileSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { OverhangSettings } from './OverhangSettings';

interface Props {
  readonly side: 'left' | 'right';
}

export function ProfileInsertionOverhangSettings({ side }: Props) {
  const dispatch = useAppDispatch();

  const profileTrussSettings = useAppSelector(getInsertingProfileTrussSettings);

  const overhangSettings =
    side === 'left' ? profileTrussSettings.profile.leftOverhang : profileTrussSettings.profile.rightOverhang;

  const updateInsertingProfileWithOverhang = (overhang: OverhangSettingsData) => {
    const newProfile =
      side === 'left'
        ? { ...profileTrussSettings.profile, leftOverhang: overhang }
        : { ...profileTrussSettings.profile, rightOverhang: overhang };
    dispatch(updateInsertingProfileTrussSettings({ ...profileTrussSettings, profile: newProfile }));
  };

  return (
    <OverhangSettings
      overhangSettings={overhangSettings}
      onChange={updateInsertingProfileWithOverhang}
      idPrefix={`${side}-`}
    />
  );
}
